import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from "./router";
import App from "./App.vue";
import store from "./store";
import LoadScript from 'vue-plugin-load-script';
// import * as types from "./store/mutation-types";

import "./assets/css/styles.css";


import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-168802688-1',
  router
});

// import VueIntercom from 'vue-intercom';
// Vue.use(VueIntercom, { appId: 'ar5xnwx5' });

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

Vue.use(ElementUI);

Vue.use(LoadScript);

new Vue({
  el: "#app",
  store,
  router,
  render: h => h(App),
  created() {
    // this.$store.commit(types.RESET_LOADING_PROGRESS);
    // this.$store.dispatch("getAllCategories");
    // this.$store.dispatch("getAllPages");
  }
});
